import { PRODUCTS } from '../config/columns.config';

const sumProducts = (obj = {}) =>
    PRODUCTS.reduce((s, p) => s + (obj[p.key] || 0), 0);

const accumulateProductsFromAccount = (account) => {
    const retail = {};
    const project = {};

    PRODUCTS.forEach(p => {
        retail[p.key] = (account.retail?.[p.key] || 0) + (account.showroom?.[p.key] || 0);
        project[p.key] = 0;
    });

    (account.projects || []).forEach(proj => {
        PRODUCTS.forEach(p => {
            project[p.key] = (project[p.key] || 0) + (proj[p.key] || 0);
        });
    });

    (account.subAccounts || []).forEach(sub => {
        const subTotals = accumulateProductsFromAccount(sub);
        PRODUCTS.forEach(p => {
            retail[p.key] = (retail[p.key] || 0) + (subTotals.retail[p.key] || 0);
            project[p.key] = (project[p.key] || 0) + (subTotals.project[p.key] || 0);
        });
    });

    return { retail, project };
};

const getSplitBudgetsFromAccount = (account) => {
    let retail = account.retailBudget || 0;
    let project = account.projectBudget || 0;

    (account.subAccounts || []).forEach(sub => {
        const subBudgets = getSplitBudgetsFromAccount(sub);
        retail += subBudgets.retail;
        project += subBudgets.project;
    });

    return { retail, project };
};

export const buildTerritorySummary = (data, config, apiTerritoryBudgets = []) => {
    const territoryMap = {};

    data.forEach(acc => {
        const territory = acc.territory || 'Unknown';
        if (!territoryMap[territory]) {
            territoryMap[territory] = [];
        }
        territoryMap[territory].push(acc);
    });

    return Object.entries(territoryMap)
        .sort(([keyA], [keyB]) =>
            keyA.localeCompare(keyB, undefined, { numeric: true, sensitivity: 'base' })
        )
        .map(([territory, accounts]) => {
            const totalRetail = {};
            const totalProject = {};
            let totalRetailBudget = 0;
            let totalProjectBudget = 0;

            PRODUCTS.forEach(p => {
                totalRetail[p.key] = 0;
                totalProject[p.key] = 0;
            });

            accounts.forEach(acc => {
                const accTotals = accumulateProductsFromAccount(acc);
                const accBudgets = getSplitBudgetsFromAccount(acc);

                PRODUCTS.forEach(p => {
                    totalRetail[p.key] += accTotals.retail[p.key] || 0;
                    totalProject[p.key] += accTotals.project[p.key] || 0;
                });

                totalRetailBudget += accBudgets.retail;
                totalProjectBudget += accBudgets.project;
            });

            const retailTotal = sumProducts(totalRetail);
            const projectTotal = sumProducts(totalProject);
            const grandTotal = retailTotal + projectTotal;

            const apiRecords = apiTerritoryBudgets.filter(t => String(t.territory) === String(territory));
            const apiRetailRecord = apiRecords.find(r => r.categoryGroup === 'RET');
            const apiProjectRecord = apiRecords.find(r => r.categoryGroup === 'PRJ');
            const finalRetailBudget = apiRetailRecord ? (apiRetailRecord.budget ?? 0) : null;
            const finalProjectBudget = apiProjectRecord ? (apiProjectRecord.budget ?? 0) : null;
            const grandTotalBudget = (finalRetailBudget || 0) + (finalProjectBudget || 0);

            const totalValues = {};
            PRODUCTS.forEach(p => {
                totalValues[p.key] = (totalRetail[p.key] || 0) + (totalProject[p.key] || 0);
            });

            return {
                territory,
                rows: [
                    {
                        label: 'Retail',
                        values: totalRetail,
                        total: retailTotal,
                        budget: finalRetailBudget,
                    },
                    {
                        label: 'Project',
                        values: totalProject,
                        total: projectTotal,
                        budget: finalProjectBudget,
                    },
                    {
                        label: 'Total',
                        values: totalValues,
                        total: grandTotal,
                        budget: grandTotalBudget,
                    },
                ],
            };
        });
};